<script>
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';
  import { addAlias, checkAlias, logout } from '../../Api/api';
  import { firebaseApp } from '../../Store/firebase-store';
  import Spinner from '../Common/Spinner.svelte';
  import { channel } from './chat-store';
  import { trackEvent } from '../../analytics';

  const dispatch = createEventDispatcher();

  export let user = null;

  let showSpinner = false;
  let alias = '';
  let msg = '';

  $: user && setAlias();
  $: spinnerColor =
    $channel &&
    ($channel.category === 'news' ||
      $channel.category === 'entertainment' ||
      $channel.category === 'sport')
      ? '#fafafa'
      : '#222222';

  const setAlias = () => {
    alias = user.displayName;
  };

  async function saveAlias(userId, alias) {
    msg = validateAlias(alias);
    if (!msg) {
      showSpinner = true;
      try {
        const res = await checkAlias(alias, $firebaseApp);
        if (res.empty) {
          await addAlias(userId, alias, $firebaseApp);
          await user.updateProfile({
            displayName: alias,
          });
        } else {
          msg = 'Alias er tatt.';
        }
      } catch (err) {
        showSpinner = false;
        msg = err;
      }
      showSpinner = false;
    }
  }

  const onSaveAlias = async () => {
    await saveAlias(user.uid, alias);
    if (!msg) {
      if ($channel) {
        trackEvent({
          action: 'Chat - Confirm changed alias',
          label: $channel.id,
          dimensions: {
            chatName: $channel.name,
            chatCategory: $channel.category,
          },
        });
      }
      dispatch('user-got-alias');
    }
  };

  const onLogoutClicked = async () => {
    showSpinner = true;
    await logout($firebaseApp);
    showSpinner = false;
    dispatch('close');

    await window?.TV2?.logout();
  };

  const validateAlias = (alias) => {
    if (alias.length <= 1) {
      return 'Alias må være minst to karakterer';
    } else if (alias.length > 20) {
      return 'Alias kan ikke være lengre enn 20 karakterer';
    }
    return '';
  };
</script>

<div class="user-settings-container" data-category={$channel && $channel.category} in:slide>
  <div class="content">
    {#if showSpinner}
      <div class="spinner">
        <Spinner color={spinnerColor} />
      </div>
    {:else}
      <div class="header">
        <h1 class="sumo-user-label">Din profil</h1>
        <button class="logout-button" on:click={onLogoutClicked}>Logg ut</button>
      </div>
      <p class="label">Chat-kallenavn</p>
      <input
        type="text"
        autocomplete="off"
        id="alias"
        name="alias"
        placeholder="Chat-kallenavn (alias)"
        bind:value={alias}
        on:change={() => (msg = '')}
      />
      <div class="error">{msg}</div>
      <button on:click={onSaveAlias} class="save-user-name-btn">Lagre kallenavn</button>
    {/if}
  </div>
</div>

<style src="./settings.scss"></style>
